export const getTabla = (tabla) => {
  const documentos = [
    { name: "ARCHIVO PERMANENTE", tableName: "archivo_permanente" },
    { name: "DECLARACIÓN ANUAL", tableName: "declaracion_anual" },
    { name: "PAGOS PROVISIONALES", tableName: "pagos_provicionales" },
    { name: "OPINIONES DE CUMPLIMIENTO", tableName: "opiniones_cumplimiento" },
    { name: "REPORTES FINANCIEROS", tableName: "reportes_financieros" },
    { name: "BUZONES", tableName: "buzones" },
    { name: "ESTADO DE CUENTA", tableName: "estado_cuenta" },
    { name: "Herramientas", tableName: "herramientas" },
  ];

  const documentoEncontrado = documentos.find(
    (doc) => doc.tableName === tabla
  );

  return documentoEncontrado ? documentoEncontrado.name : "Documento no encontrado";
};
